export default __webpack_public_path__ + "static/media/check-circle.8737a276.svg";